import type { WorkerDetailFragment } from "@/gql/graphql";

export const getWorkerDisplayName = (worker: WorkerDetailFragment): string => {
  return worker.displayName || "Unnamed Worker";
};

export const getWorkerInitials = (worker: WorkerDetailFragment): string => {
  return worker.displayName
    .split(" ")
    .map((n) => n[0])
    .join("");
};
